
var article = `
## Problemas para grabar la pantalla en Windows 10

* Ir al acceso directo del programa, *clic derecho* **>** *Propiedades*

* En la propiedad **Destino** agrego la línea **--allow-opengl** *al final*.

* De manera que quede algo así:

> "C:\\Program Files\\obs-studio\\bin\\64bit\\obs64.exe" **--allow-opengl**
      
* Después abrir la aplicación desde ese acceso directo, ir a *Ajustes*.
* Ir a la pestaña **Avanzado** y al sector **Vídeo** que está dentro de dicha pestaña. 
* En la propiedad **Renderizador** seleccionar **OpenGL**.

* Aplicar cambios y reiniciar el programa.

**NOTA:** es **importante** abrir el programa *desde el acceso directo* en el que hayamos agregado la línea **--allow-opengl**.
`;

export default article